import { useRef } from 'react';
import { useLogoSplash } from '../hooks/useLogoSplash.js';
import { withBasePath } from '../utils/paths.js';

export default function LogoSplash() {
  const splashRef = useRef(null);
  const logoRef = useRef(null);
  useLogoSplash(splashRef, logoRef);

  return (
    <div
      ref={splashRef}
      id="v4LogoSplash"
      className="v4-logo-splash"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading Afroport Mauritanie SARL"
    >
      <div className="v4-logo-splash__inner">
        <img
          ref={logoRef}
          src={withBasePath('/assets/logo.png')}
          alt="Afroport Mauritanie SARL"
          className="v4-logo-splash__logo"
          width="480"
          height="180"
          fetchPriority="high"
          decoding="async"
        />
        <div className="v4-logo-splash__bar" aria-hidden="true">
          <span />
        </div>
        <p className="v4-logo-splash__caption">Nouakchott Oumtounsy International Airport (NKC/GQNO)</p>
      </div>
    </div>
  );
}
